export const isValidText = (text: string) => !/^\s*$/.test(text);
